export default "__VITE_ASSET__b46ca376__"